export default __webpack_public_path__ + "static/media/home.33f1148a.jpg";